module.exports = __webpack_public_path__ + "static/media/create.1f4f3622.svg";